// @need-translate
import {twMerge} from '../../../common/twMerge';
import {TalkPosition} from '../../../domain/content/[seriesId]/viewer/[productId]/type/TalkPosition.enum';
import {TalkShapeType} from '../../../domain/content/[seriesId]/viewer/[productId]/type/TalkShapeType.enum';
import {TalkType} from '../../../domain/content/[seriesId]/viewer/[productId]/type/TalkType.enum';
import {theme} from '../../../theme';
import {TalkShape} from '../TalkShape/TalkShape';
import {WebpImageWithApngFallback} from '../WebpImageWithApngFallback/WebpImageWithApngFallback';
import {TalkImageProps} from './TalkImageProps.interface';

export function TalkImage({
  isIos,
  imageUrl,
  apngUrl,
  widthPx = 0,
  heightPx = 0,
  alt = '이미지',
  authorship,
  talkPosition,
  talkType,
  talkShapeType,
  talkColor,
  characterName,
  characterNameColor,
  isFullscreenImg,
}: TalkImageProps) {
  const ratio = heightPx / widthPx;
  const isWebp = imageUrl.includes('.webp');

  return (
    <TalkShape
      className={twMerge(
        talkShapeType === TalkShapeType.Bubble &&
          BUBBLE_TALK_TYPE_STYLE[talkType],
        talkType === TalkType.Omniscient &&
          talkPosition === TalkPosition.Center &&
          'w-660tvs',
        isFullscreenImg && 'w-660tvs'
      )}
      talkShapeType={talkShapeType}
      characterName={characterName}
      characterNameColor={characterNameColor}
      talkPosition={talkPosition}
      talkColor={talkColor}
    >
      <div
        // eslint-disable-next-line tailwindcss/no-custom-classname
        className={twMerge(
          'talk-image-container',
          'relative inline-flex w-full overflow-hidden',
          talkShapeType === TalkShapeType.Box &&
            talkType !== TalkType.Omniscient &&
            'w-430tvs'
        )}
      >
        <WebpImageWithApngFallback
          imageUrl={imageUrl}
          apngUrl={isWebp ? apngUrl : undefined}
          width="100%"
          alt={alt}
          isIos={isIos}
          className={twMerge(
            'absolute top-0 left-0 box-border',
            !ratio && 'static',
            TALK_SHAPE_TYPE_IMG_STYLE[talkShapeType],
            talkShapeType === TalkShapeType.Box &&
              talkType === TalkType.Omniscient &&
              'w-full'
          )}
          isWebp={isWebp}
        />
        {authorship && (
          <div
            className={twMerge(
              // TODO: @Root-huh text-[#333] - 매칭되는 디자인 토큰 없음
              'absolute bottom-12tvs w-full text-right text-22tvs text-[#333] opacity-40',
              talkPosition === TalkPosition.Left && 'text-left'
            )}
          >
            출처
            <span style={{verticalAlign: theme.spacing['2tvs']}}>:</span>
            {authorship}
          </div>
        )}
      </div>
      <style jsx>
        {`
          .talk-image-container::after {
            content: '';
            display: block;
            padding-top: calc(
              ${`${ratio * 100}%`} +
                ${authorship ? theme.spacing['52tvs'] : '0px'}
            );
          }
        `}
      </style>
    </TalkShape>
  );
}

const BUBBLE_TALK_TYPE_STYLE: {[key in TalkType]: string} = {
  [TalkType.Narration]: '',
  [TalkType.Omniscient]: 'w-567tvs',
  [TalkType.Talker]: 'w-426tvs',
  [TalkType.None]: '',
};

const TALK_SHAPE_TYPE_IMG_STYLE: {[key in TalkShapeType]: string} = {
  [TalkShapeType.Box]: 'rounded-8tvs',
  [TalkShapeType.Bubble]: 'rounded-26tvs',
  [TalkShapeType.None]: '',
};
